// extracted by mini-css-extract-plugin
module.exports = {"container":"_24vr-","language":"_1fnOh"};